import { PricingCard } from './pricing-card';

export class AppliedPricingCardPrice {
	productId: number;
	pricingCardTypeId: number;
	petProtectionScopeId?: number | null;
	card: PricingCard | null;
	isDefault: boolean;
}
